// Allow h2 tags
Trix.config.blockAttributes.heading2 = {
  tagName: "h2",
  terminal: true,
  breakOnReturn: true,
  group: false,
}

// Handle new lines by wrapping in a p tag
Trix.config.blockAttributes.default.tagName = "p"
Trix.config.blockAttributes.default.breakOnReturn = true

// Break out of p tags on return
Trix.Block.prototype.breaksOnReturn = function(){
  let attr = this.getLastAttribute()
  attr = attr ? attr : "default"
  return Trix.config.blockAttributes[attr]["breakOnReturn"]
}

Trix.LineBreakInsertion.prototype.shouldInsertBlockBreak = function(){
  if(this.block.hasAttributes() && this.block.isListItem() && !this.block.isEmpty()) {
    return this.startLocation.offset > 0
  } else {
    return !this.shouldBreakFormattedBlock() ? this.breaksOnReturn : false
  }
}
